import /*React,*/ { Component } from 'react';
import { connect } from 'react-redux';
import {
//    BrowserRouter as Router,
//    Route,
//    Link,
    withRouter
} from 'react-router-dom'

/* eslint-disable prefer-template */
/* eslint-disable import/prefer-default-export */
//import fetch from 'isomorphic-fetch';
//import { loggedIn, loggedOut } from '../../actions/index'

const LOCAL_STORAGE_KEY = 'my-dns-auth';

// There are risks with using localStorage for API tokens in a production
// application. You open yourself up to XSS attacks. If malicious
// JavaScript makes it into your app, that JavaScript will have access
// to localStorage and therefore any sensitive tokens.

// For more info on token management, see this article:
// https://auth0.com/blog/cookies-vs-tokens-definitive-guide/

class MyAuthContainer extends Component {
    constructor(props) {
        super(props);

        this.useLocalStorage = (typeof localStorage !== 'undefined');

        if (this.useLocalStorage) {
            this.token = localStorage.getItem(LOCAL_STORAGE_KEY);
//            console.log('token loaded: ', this.token);

            if (this.token) {
                // we might be logged in (if not, getProfile will log us out)
                this.props.dispatch({ type: 'set_session', payload: { session: this.token } });
            } else {
//                console.log('logout');
                this.props.dispatch({ type: 'logged_out' });
            }
        } else {
//            console.log('do not use localStorage');
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.session != prevProps.session) {
            // session changed
            if (this.props.session) {
                this.setToken(this.props.session);
            } else {
                this.removeToken();
            }
        }
    }

    componentDidMount() {
    }
/*
    isLoggedIn() {
        return !!this.token;
    }
*/
    setToken(token) {
        this.token = token;

        if (this.useLocalStorage) {
            localStorage.setItem(LOCAL_STORAGE_KEY, token);
//            console.log('MY: token ',LOCAL_STORAGE_KEY,' set to ',token);
        }
    }

    removeToken = () => {
        this.token = null;

        if (this.useLocalStorage) {
            localStorage.removeItem(LOCAL_STORAGE_KEY);
//            console.log('MY: token ',LOCAL_STORAGE_KEY,' removed');
        }

        this.props.dispatch({ type: 'logged_out' });
    }

    render() {
        return false;
    }
}

const mapStateToProps = function(state){
    return {
        apiUrl: state.api.url,
//        apiKey: state.config.apiKey,
//        logApi: state.config.logApi,
        session: state.api.session,
    }
}

export default withRouter(connect(mapStateToProps)(MyAuthContainer));
